import PATH from '../paths';

const name = 'Stock Capital';
const key = 'stockcapital';
const imgUrl = `${ PATH.CDN }/whitelabels/stockcapital`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/logo.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  logoSidebar: `${ imgUrl }/logo.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-sc-gold:                  rgb(204,180,106);
    --color-sc-gold-dark:             rgb(191, 146, 61);

    --color-primary:                  var(--color-darker);
    --color-secondary:                var(--color-darker);
    --color-accent:                   var(--color-sc-gold);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-blue);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              transparent;
    --anonymous-copy-bg:              var(--color-sc-gold-dark);
    --anonymous-heading-color:        var(--color-light);
    --anonymous-subheading-color:     var(--color-light);
    --anonymous-text-color            var(--color-light);
    --anonymous-logo-height:          65px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-dark);
    --sidebar-logo-bg-color: var(--color-darker);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 1);
    --sidebar-border-color: var(--color);

    --sidebar-button-color: var(--color-sc-gold-dark);
    --sidebar-button-color-active: var(--color-darker);
    --sidebar-button-color-hover: var(--color-sc-gold-dark);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-sc-gold-dark);
    --sidebar-button-bg-color-hover: transparent;
    --sidebar-button-border-color: var(--color-sc-gold-dark);
    --sidebar-button-border-color-active: var(--color-sc-gold-dark);
    --sidebar-button-border-color-hover: var(--color-sc-gold-dark);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-sc-gold-dark);
    --btn-primary--border:            var(--color-sc-gold-dark);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-sc-gold-dark);
    --btn-primary--borderH:           var(--color-sc-gold-dark);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-sc-gold-dark);
    --btn-secondary--color:           var(--color-sc-gold-dark);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-sc-gold-dark);
    --btn-secondary--colorH:          var(--color-sc-gold-dark);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
